<!-- eslint-disable no-shadow -->
<!-- eslint-disable no-undef -->
<script>
export default {
    name: "google-map",
    props: {
        // eslint-disable-next-line vue/require-prop-type-constructor
        lat: "",
        // eslint-disable-next-line vue/require-prop-type-constructor
        lng: "",
        // eslint-disable-next-line vue/require-prop-type-constructor
        radius: "",
        zoom: {
            type: Number,
            default: 10,
        },
        // eslint-disable-next-line vue/require-prop-type-constructor
        noMovePin: false,
    },
    emits: [
        "userClickedMap",
        "addressUpdated",
    ],
    data() {
        return {
            mapOptions: {
                center: { lat: 51.50844, lng: -0.10970 },
                zoom: 10,
                streetViewControl: false,
                fullscreenControl: false,
                mapTypeControl: false,
                gestureHandling: "greedy",
            },
            map: "",
            marker: "",
            addressComponents: [],
            address: {},

            circle: "",
        };
    },
    methods: {
        initMap() {
            this.map = new google.maps.Map(this.$refs.googleMap, {
                ...this.mapOptions,
            });
        },
        setSingleMarker() {
            if (this.marker === "") {
                this.marker = new google.maps.Marker({
                    position: { lat: this.lat, lng: this.lng },
                    animation: google.maps.Animation.DROP,
                });

                this.marker.setMap(this.map);
            } else {
                this.marker.setPosition({ lat: this.lat, lng: this.lng });
            }

            if (this.marker) {
                const position = this.marker.getPosition();

                if (!Number.isNaN(position.lat()) && !Number.isNaN(position.lng())) {
                    this.map.setCenter(this.marker.getPosition());
                    this.map.setZoom(this.zoom);
                    this.setCirclePosition();
                }
            }
        },

        setCirclePosition() {
            if (this.circle === "") {
                if (this.marker !== "") {
                    // eslint-disable-next-line radix
                    const radius = parseInt(this.radius) * 1000 || 0;
                    this.circle = new google.maps.Circle({
                        center: this.marker.getPosition(),
                        radius,
                        map: this.map,
                        fillColor: "#0397A8",
                        fillOpacity: 0.50,
                        strokeColor: "#0397A8",
                        strokeOpacity: 0.5,
                    });
                }
            } else {
                // eslint-disable-next-line radix
                const radius = parseInt(this.radius) * 1000 || 0;
                this.circle.setCenter(this.marker.getPosition());
                this.circle.setRadius(radius);
            }
        },

        parseAddress(components) {
            let postcode;
            let county;
            let city;
            let houseNumber;
            let street;
            let
                address;
            // eslint-disable-next-line array-callback-return
            components?.map((el) => {
                // eslint-disable-next-line array-callback-return
                el.types.map((type) => {
                    // eslint-disable-next-line default-case
                    switch (type) {
                    case "postal_code":
                        postcode = postcode === undefined ? el.short_name : postcode;
                        break;
                    case "neighborhood":
                    case "sublocality":
                        county = county === undefined ? el.short_name : county;
                        break;
                    case "postal_town":
                        city = city === undefined ? el.short_name : city;
                        break;
                    case "subpremise":
                    case "street_number":
                        houseNumber = houseNumber === undefined ? el.short_name : houseNumber;
                        break;
                    case "premise":
                    case "route":
                        street = street === undefined ? el.short_name : street;
                        break;
                    }
                });
            });

            address = houseNumber !== undefined ? `${houseNumber}, ${street}` : street;
            county = county === undefined ? "N/A" : county;

            // Set value to empty string to show errors for users and notify them that they need to add data manually
            if (postcode === undefined || postcode === "N/A") {
                postcode = "";
            }

            if (county === undefined || county === "N/A") {
                county = "";
            }

            if (city === undefined) {
                city = "";
            }

            if (houseNumber === undefined) {
                houseNumber = "";
            }

            if (street === undefined) {
                street = "";
            }

            if (address === undefined) {
                address = "";
            }

            this.address = {
                address, county, postcode, city,
            };

            this.$emit("addressUpdated", this.address);
        },
        getParsedAddress(lat, lng) {
            const response = this.getFullAddress(lat, lng);
            response.done((response) => {
                this.parseAddress(response.results?.address_components);
                this.$emit("addressUpdated", this.address);
            });
        },
        getFullAddress(lat, lng) {
            return $.ajax({
                url: "/ajax/get-address",
                method: "POST",
                data: {
                    latLng: `${lat.toString()},${lng.toString()}`,
                },
                dataType: "json",
            });
        },
        userClickedLocationOnMap() {
            this.$emit("userClickedMap");
        },
    },
    watch: {
        lat() {
            this.setSingleMarker();
        },

        radius() {
            this.setCirclePosition();
        },
        // zoom() {
        //     this.mapOptions.zoom = this.zoom;
        // },
    },
    mounted() {
        this.initMap();

        if (this.noMovePin === true) {
            this.setSingleMarker();
        } else {
            google.maps.event.addListener(this.map, "click", (event) => {
                const { lat, lng } = event.latLng;
                const request = this.getFullAddress(lat(), lng());

                this.userClickedLocationOnMap(event); // phew (was stuggling with this) thankfully here , google only fires click , when not click zooms OR click/dragging map

                request.done((response) => {
                    this.parseAddress(response.results.address_components);

                    this.$emit("locationChange", {
                        lat, lng, address: this.address, autocomplete: response.address,
                    });
                });
            });
        }
    },
};
</script>
<template>
    <div>
        <div ref="googleMap" class="google-map"></div>
    </div>
</template>

<style>
.google-map {
    width: 430px;
    height: 385px;
}
</style>
